var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSendIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1813_740)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1686 6.83133L9.24852 12.3302L0.964497 9.56848C0.386258 9.37534 -0.00330584 8.83282 2.11451e-05 8.22332C0.00339191 7.61383 0.397421 7.07464 0.977892 6.88824L22.1573 0.0676976C22.6607 -0.0941427 23.2133 0.038674 23.5873 0.412654C23.9612 0.786633 24.0941 1.33918 23.9322 1.84264L17.1117 23.022C16.9253 23.6025 16.3861 23.9965 15.7766 23.9999C15.1671 24.0032 14.6246 23.6137 14.4314 23.0354L11.6563 14.7113L17.1686 6.83133Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1813_740"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendIcon);
export default __webpack_public_path__ + "static/media/SendIcon.d2379a12afb10d207f231b94dba3cb04.svg";
export { ForwardRef as ReactComponent };